import { render, staticRenderFns } from "./roleUser.vue?vue&type=template&id=e08d68f6&"
import script from "./roleUser.vue?vue&type=script&lang=js&"
export * from "./roleUser.vue?vue&type=script&lang=js&"
import style0 from "./roleUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "roleUser.vue"
export default component.exports